// import React from 'react';
import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';
import customerVNS from './constants/customerVNS';

export default data => {
  const dataCreate = parseToMutationRequest(data, customerVNS);
  const modifyAccount = `modifyAccount(input: ${dataCreate})`;

  return gql`
  mutation {
    ${modifyAccount} {
      id
      parentId
      customerSegment
      type
      subType
      salesChannel
      marketSegment
      sellingCompany
      lineOfBusiness
      legalEntity
      currency
      status
      reason
      effectiveDate
      salesAgentId
      clientId
      type
      region
      externalRefId
      collectionAgent
      contacts {
        id
        roles
        salutation
        firstName
        middleName
        lastName
        position
        organization
        email
        phones {
          type
          number
        }
      }
      addresses {
        id
        roles
        street
        extraLine
        landmark
        city
        state
        country
        postalCode
        code
      }
      billingProfiles {
        id
        parentId
        billingDom
        billingSegment
        billingFrequency
        invoiceType
        invoiceDelivery
        paymentProfileId
      }
      paymentProfiles {
        id
        paymentTerm
        paymentMethod
        creditCards {
          cardToken
          cardExpiry
          last4CC
          merchant
        }
      }
      customAttributes {
        name
        value
      }
    }
  }
`;
};
